import {
  Disclaimer,
  Div,
  TooltipWrapper,
  lightTheme,
} from '@vgrubs/components';
import type { AnnouncementViewerPreview } from '../../../types/api/announcements.types';
import { ConversationAvatar } from '../../Chat/components/ConversationAvatar';
import { formatSeenAtFull, viewerName } from '../helpers/announcementViewers';
import { BubbleStack, MoreBubble } from './AnnouncementSeenBy.styled';

type Props = {
  seenCount: number;
  /** Up to the 5 latest viewers, newest first - drawn left to right. */
  seenPreview: AnnouncementViewerPreview[];
  size?: number;
};

/**
 * "Seen by 47" with the latest few faces over it, for a row of the list.
 *
 * The count is the backend's `seenCount`, never the preview's length: the
 * preview stops at five, and the "+N" disc is the difference between them.
 */
export const AnnouncementSeenBy = ({
  seenCount,
  seenPreview,
  size = 28,
}: Props) => {
  if (!seenCount) {
    return (
      <Disclaimer $m="0" $color={lightTheme.lightGray}>
        No views yet
      </Disclaimer>
    );
  }

  const more = seenCount - seenPreview.length;

  return (
    <Div $flex $column $alignEnd $gap="4px">
      <BubbleStack>
        {seenPreview.map((viewer) => (
          <TooltipWrapper
            key={viewer.userId}
            tooltip={`${viewerName(viewer)} · ${formatSeenAtFull(
              viewer.lastSeenAt
            )}`}
            style={{ display: 'flex' }}
          >
            <ConversationAvatar name={viewerName(viewer)} size={size} />
          </TooltipWrapper>
        ))}
        {more > 0 && <MoreBubble $size={size}>+{more}</MoreBubble>}
      </BubbleStack>
      <Disclaimer $m="0" $color={lightTheme.lightGray}>
        Seen by {seenCount}
      </Disclaimer>
    </Div>
  );
};
